import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "./AtiraIcon";
import { Button } from "./Button";
import { Flex } from "./Flex";
import { Text } from "./Text";
import { Modal } from "./modal/Modal";
import { Info } from "./Info";

const DenyButton = styled(Button)`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.black};
  width: fit-content;
  height: 2.5rem;
  color: ${({ theme }) => theme.black};

  &:hover {
    background-color: ${({ theme }) => theme.black};
    color: ${({ theme }) => theme.white};
  }
`;

const ConfirmButton = styled(Button)`
  min-width: 5rem;
  height: 2.5rem;
`;

interface WarningModalProps {
  title?: string;
  description?: string | React.ReactNode;
  onConfirm?: VoidFunction;
  loading?: boolean;
  isOpen: boolean;
  onClose?: VoidFunction;
  //
  confirmButtonText?: string;
  confirmButtonDataTestId?: string;
  denyButtonText?: string;
  denyButtonDataTestId?: string;
  zIndex?: number;
}

export const WarningModal: React.FC<WarningModalProps> = ({
  title,
  description,
  onConfirm,
  onClose,
  loading,
  isOpen,
  confirmButtonText,
  confirmButtonDataTestId,
  denyButtonDataTestId,
  denyButtonText,
  zIndex = 2002,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={t("common.warning")}
      zIndex={zIndex}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s"
      >
        <Flex width={"4rem"}>
          <AtiraIcon icon={faTriangleExclamation} size="4x" color="main" />
        </Flex>

        <Flex>
          <Text fontSize="l" align="center" color="textColor">
            {title ? title : t("common.are_you_sure")}
          </Text>
        </Flex>

        <Flex>
          <Info
            color="textColor"
            info={
              description ? description : t("forms.delete.modal.description")
            }
          />
        </Flex>

        <Flex gap="xl">
          <DenyButton onClick={onClose} dataTestId={denyButtonDataTestId}>
            {denyButtonText || t("common.no")}
          </DenyButton>

          <ConfirmButton
            hover
            loading={loading}
            onClick={onConfirm}
            dataTestId={confirmButtonDataTestId}
          >
            {confirmButtonText || t("common.yes")}
          </ConfirmButton>
        </Flex>
      </Flex>
    </Modal>
  );
};
